import { createFileRoute } from "@tanstack/react-router";
import AdminSentryPage from "@/admin/pages/sentry";

export const Route = createFileRoute("/admin/sentry")({
  component: AdminSentryPage,
});
